var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "offscreen__menu", class: _vm.toggle ? "open" : "" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "userProfileModal",
            title: _vm.userProfileTitle
          }
        },
        [_c("UserProfileModal", { ref: "refUserProfileModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "top-section" }, [
        _c("div", { staticClass: "user__initials" }, [
          _c("div", { staticClass: "logged-in-user" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm._f("textInitials")(_vm.userName)) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "fullname" }, [
          _vm._v("\n            " + _vm._s(_vm.userName) + "\n        ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "secondary-menu" }, [
        _c("ul", [
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.$bvModal.show("userProfileModal")
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-fw fa-cog" }),
                _vm._v("\n                    My Account\n                ")
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.$bvModal.show("feedbackModal")
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-fw fa-question" }),
                _vm._v("\n                    Feedback\n                ")
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.logout.apply(null, arguments)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-fw fa-sign-out-alt" }),
                _vm._v("\n                    Logout\n                ")
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-section" }, [
        _vm._v("\n        Workflow\n    ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }